import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useOrderContext } from "../../../../contexts/OrderContext";
import { SavedProgressReducerActionTypes } from "../../../../contexts/reducers/savedProgressReducer";
import OutboundScheduleForm from "../../components/forms/outboundScheduleForm/OutboundScheduleForm";
import BaseContent from "../BaseContent";

interface ScheduleScreenProps {}

const ScheduleScreen = (props: ScheduleScreenProps) => {
  const { t } = useTranslation();
  const { savedProgress, dispatchSavedProgress } = useOrderContext();

  const [goodsIssuePlanned, setGoodsIssuePlanned] = useState<Date | null>(null);
  const [deliveryDatePlanned, setDeliveryDatePlanned] = useState<Date | null>(
    null,
  );

  const loadSavedProgress = () => {
    if (!savedProgress) return;

    if (savedProgress.goodsIssuePlanned) {
      setGoodsIssuePlanned(savedProgress.goodsIssuePlanned);
    }
    if (savedProgress.deliveryDatePlanned) {
      setDeliveryDatePlanned(savedProgress.deliveryDatePlanned);
    }
  };

  const saveProgress = () => {
    if (goodsIssuePlanned) {
      dispatchSavedProgress({
        type: SavedProgressReducerActionTypes.SET_PROP,
        property: "goodsIssuePlanned",
        value: goodsIssuePlanned,
      });
    }

    if (deliveryDatePlanned) {
      dispatchSavedProgress({
        type: SavedProgressReducerActionTypes.SET_PROP,
        property: "deliveryDatePlanned",
        value: deliveryDatePlanned,
      });
    }
  };

  useEffect(() => {
    loadSavedProgress();
  }, []);

  return (
    <BaseContent
      screenName={"outboundScheduleScreen"}
      disableNext={!goodsIssuePlanned}
      proceedButtonText={t("proceedSummary")}
      saveProgress={saveProgress}
    >
      <div className="form-component">
        <OutboundScheduleForm
          goodsIssuePlanned={goodsIssuePlanned}
          setGoodsIssuePlanned={setGoodsIssuePlanned}
          deliveryDatePlanned={deliveryDatePlanned}
          setDeliveryDatePlanned={setDeliveryDatePlanned}
        />
      </div>
    </BaseContent>
  );
};
export default ScheduleScreen;
